//@flow
import { compose, lifecycle } from 'recompose'
import { ModalBody, ModalHeader } from 'reactstrap'
import { connect } from 'react-redux'

import { Modal } from 'common-components/index'
import type { AppState } from 'quick-quote/reducers'
import _ from 'lodash'

class EkycRevalidateAge extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSkipEkyc: false,
    }
  }

  render() {
    const { isLoading } = this.props
    return (
      <Modal className={''} isOpen={isLoading} size="md" modalClassName="default-bootstrap remote-selling-modal">
        <ModalHeader className={'header-modal'} style={{ display: 'flex', justifyContent: 'center' }}>
          ขณะนี้ระบบอยู่ระหว่างดำเนินการคำนวนเบี้ยใหม่
        </ModalHeader>
        <ModalBody>
          <div className={'flex-container'} style={{ display: 'flex', justifyContent: 'center' }}>
            เนื่องจากอายุเปลี่ยนกรุณาอย่าปิดแอพ
          </div>
        </ModalBody>
      </Modal>
    )
  }
}

const mapStateToEkycRevalidateAge = (state: AppState, props) => {
  return {
    isLoading: _.get(state, ['ui', 'isModalLoading'], false),
  }
}

export default compose(
  connect(mapStateToEkycRevalidateAge),
  lifecycle({
    componentDidMount() {},
    componentDidUpdate(prevProps) {},
  })
)(EkycRevalidateAge)
